import { useState } from 'react';

import { useIdpAuth } from '@/context/IdpAuth/IdpAuthContext';

import { Divisor, ErroDeLogin, SeazoneButton } from './styles';

import { dentroDeMoldura } from '@/lib/moldura';

/**
 * "Entrar com Seazone" — a porta do IDP ao lado do formulario de senha.
 *
 * So aparece com `REACT_APP_IDP_LOGIN` em `both` ou `idp-only`: com `off`, e
 * com a variavel mal configurada, o componente nao renderiza nada e a tela fica
 * exatamente como era. E o que permite ligar e desligar a virada por ambiente,
 * sem release. Em `idp-only` vem sozinho, sem o divisor "ou": nao ha formulario
 * de senha ao lado.
 *
 * Dentro de iframe (o Programa de Indicacao no portal do franqueado) tambem nao
 * renderiza: o IDP recusa ser carregado em moldura. Em `both` a moldura fica
 * com a senha; em `idp-only` nao ha login algum la dentro, e o `/login` oferece
 * o Sapron em aba nova.
 */
interface IdpLoginProps {
  /**
   * A rota pedida antes do login (o `state.from` do `RequireAuth`). Vai no
   * `returnTo` da tentativa para o callback voltar a ela, como a senha volta.
   */
  readonly returnTo?: string;
}

const IdpLogin = ({ returnTo }: IdpLoginProps) => {
  const { config, login, error } = useIdpAuth();
  const [indo, setIndo] = useState(false);

  if (!config.enabled || dentroDeMoldura()) return null;

  const entrar = () => {
    setIndo(true);
    // `login()` sai do app por redirect; se voltar, foi porque falhou.
    login(returnTo).finally(() => setIndo(false));
  };

  return (
    <>
      {config.passwordLogin && (
        <Divisor>
          <span>ou</span>
        </Divisor>
      )}
      <SeazoneButton
        type="button"
        variant="outlined"
        data-cy="idp-login"
        disabled={indo}
        onClick={entrar}
      >
        {indo ? 'Redirecionando...' : 'Entrar com Seazone'}
      </SeazoneButton>
      {error !== undefined && <ErroDeLogin>{error}</ErroDeLogin>}
    </>
  );
};

export default IdpLogin;
